import { CFDI_SYNC_STATUS } from 'lib/enums/shared.enums'
import { getFormattedDate } from 'lib/helpers/shared.helpers'
import useDialog from 'hooks/Shared/useDialog'
import { useAppSelector } from 'store/hooks'
import { selectCFDISyncInformation } from 'store/SharedData/sharedData.selectors'
import Button from 'components/Shared/Button/Button'
import SyncInformationDetailsTable from '../SyncInformationDetailsTable/SyncInformationDetailsTable'
import './styles.scss'

interface ISyncInformationButtonProps {
  loading?: boolean
}

const SyncInformationButton = ({ loading }: ISyncInformationButtonProps) => {
  const dialog = useDialog()

  const CFDISyncInformation = useAppSelector(selectCFDISyncInformation)

  const ongoingSyncProcesses = CFDISyncInformation.filter(
    ({ status }) => status === CFDI_SYNC_STATUS.ONGOING
  )
  const completedSyncProcesses = CFDISyncInformation.filter(
    ({ status }) => status !== CFDI_SYNC_STATUS.ONGOING
  )

  const sortedCompletedSyncProcesses = completedSyncProcesses.sort(
    (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
  )
  const openSyncInformationDetails = () => {
    dialog.primary({
      title: 'Historial de sincronización',
      modalContent: (
        <div className="sync-information-modal-component">
          <SyncInformationDetailsTable
            ongoingSyncProcesses={ongoingSyncProcesses}
            completedSyncProcesses={completedSyncProcesses}
          />
          {!!ongoingSyncProcesses.length && (
            <div className="ongoing-process-info">
              <span>Esta consulta podría tomar un tiempo</span>
              <ul>
                <li>
                  En algunos casos, una sincronización de una gran cantidad de
                  CFDIs podría tardar hasta 72 horas en completarse.
                </li>
                <li>
                  Mientras haya una sincronización en curso, no podrá realizarse
                  una consulta idéntica al mismo tiempo.
                </li>
                <li>Te sugerimos realizar consultas precisas.</li>
              </ul>
            </div>
          )}
        </div>
      ),
      fullWidth: true,
    })
  }

  return (
    <article className="sync-information-button-component">
      {ongoingSyncProcesses.length > 0 && (
        <span>Hay una sincronización en curso</span>
      )}
      {!ongoingSyncProcesses.length && !!completedSyncProcesses.length && (
        <span>
          Última sincronización{' '}
          {getFormattedDate(sortedCompletedSyncProcesses[0].createdAt)}
        </span>
      )}
      {(!!ongoingSyncProcesses.length || !!completedSyncProcesses.length) && (
        <Button
          variant="link"
          onClick={openSyncInformationDetails}
          activity={loading}>
          Ver detalles
        </Button>
      )}
    </article>
  )
}

export default SyncInformationButton
